var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"my-button  ",class:[("my-button--" + _vm.type), { 'is-disabled': _vm.disabled }],attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }